import { render } from "./NotificationBar.vue?vue&type=template&id=54b284ec&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=54b284ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54b284ec"

export default script